import React, { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useMessage } from 'modules/intl';
import { useLabelsFormFieldContext } from 'modules/timesheet-labels';
import { Label, TimeSignalAttribute } from 'graphql/types';
import { CommentInput } from './components/CommentInput';

export type TimesheetCommentLabelProps = {
  label: Label;
  index: number;
  attributes?: TimeSignalAttribute[] | undefined;
};

export const TimesheetCommentLabel: React.FC<TimesheetCommentLabelProps> = ({
  label,
  index,
  attributes
}: TimesheetCommentLabelProps) => {
  const {
    timesheetLabels: timesheetLabelsFormField
  } = useLabelsFormFieldContext();
  const placeholderMessage = useMessage(
    'timesheetLabels.timesheetCommentPlaceholder'
  );
  const { control } = useFormContext();

  const fieldName = useMemo(
    () => `${timesheetLabelsFormField}.${index}.label`,
    [index, timesheetLabelsFormField]
  );

  return (
    <Controller
      render={({ field: { value, onChange, name } }) => (
        <CommentInput
          label={value}
          fieldName={name}
          onChange={onChange}
          placeHolder={placeholderMessage}
          attributes={attributes}
        />
      )}
      data-testid="timesheetCommentLabel"
      name={fieldName}
      key={label.id}
      control={control}
      defaultValue={label}
    />
  );
};
